import React from "react";

export const iconCheck = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3178 3.92748C12.634 4.19503 12.6734 4.66827 12.4059 4.98447L6.90588 11.4845C6.76799 11.6474 6.56719 11.7439 6.3538 11.7497C6.14041 11.7556 5.93465 11.6702 5.78808 11.515L2.95474 8.51498C2.67033 8.21384 2.6839 7.73916 2.98503 7.45476C3.28617 7.17035 3.76085 7.18391 4.04526 7.48505L6.30263 9.87521L11.2608 4.01556C11.5284 3.69935 12.0016 3.65992 12.3178 3.92748Z"
      fill="#83CC5E"
    />
  </svg>
);

export const iconArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7613 5.25318C13.0796 5.58227 13.0796 6.11004 12.7613 6.43913L8.5946 10.7468C8.26808 11.0844 7.73192 11.0844 7.4054 10.7468L3.23874 6.43913C2.92042 6.11004 2.92042 5.58227 3.23874 5.25318C3.56526 4.91561 4.10141 4.91561 4.42793 5.25318L8 8.94615L11.5721 5.25318C11.8986 4.91561 12.4347 4.91561 12.7613 5.25318Z"
      fill="#EF3340"
    />
  </svg>
);
